<template>
  <div class="CR">
    <div class="top">
      <a href="#/ApprovalIndex">
        <img
          src="../assets/images/adidas.png"
          style="width: 160px; height: 37px; margin-top: 10px"
        />
      </a>
      <a
        @click="backAddSummary()"
        style="margin-top: 10px; margin-left: 30px; float: left"
      >
        <img src="../assets/icon/back2.png" />
      </a>
    </div>
    <div class="content_title">
      <div class="CR-btn">
        <div class="search-year">
          <div class="label">Financial Year：</div>
          <el-select
            v-model="Year"
            placeholder="Please select"
            style="
              margin-left: 5px;
              margin-right: 10px;
              flex: 1;
              max-width: 200px;
            "
          >
            <el-option
              v-for="item in YearOption"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>
        <el-button class="button-search" @click="CreateCR()" :disabled="loading"
          >Create</el-button
        >
      </div>
      <div class="cr-add-table">
        <div class="title">New</div>
        <div class="table" ref="table">
          <el-table
            ref="multipleTable"
            v-loading="loading"
            :data="newTableData"
            :header-cell-style="tableHeaderCell"
            :cell-style="tableCell"
            border
            style="width: 100%"
            tooltip-effect="dark"
          >
            <template>
              <el-table-column
                :prop="item.value"
                :label="item.label"
                v-for="(item, index) in tableColumn"
                :key="index"
                show-overflow-tooltip
              ></el-table-column>
            </template>
          </el-table>
        </div>
      </div>
      <div class="cr-add-table cr-upgrade-table">
        <div class="title">Upgrade</div>
        <div class="table" ref="table">
          <el-table
            ref="multipleTable"
            v-loading="loading"
            :data="upTableData"
            :header-cell-style="tableHeaderCell"
            :cell-style="tableCell"
            border
            style="width: 100%"
            tooltip-effect="dark"
          >
            <template>
              <el-table-column
                :prop="item.value"
                :label="item.label"
                v-for="(item, index) in tableColumn"
                :key="index"
                show-overflow-tooltip
              ></el-table-column>
            </template>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      upTableData: [],
      newTableData: [],
      tableColumn: [
        // {
        //   label: "No.",
        //   value: "tempCRNO",
        // },
        {
          label: "Project Code#",
          value: "projectCode",
        },
        {
          label: "Capex(w/ VAT)",
          value: "capex",
          sort: 0,
        },
        {
          label: "Opex(w/ VAT)",
          value: "opex",
          sort: 3,
        },
        {
          label: "Digital(w/ VAT)",
          value: "digital",
          sort: 4,
        },
      ],
      loading: false,
      IDs: [],
      pagenum: 20,
      loading: false,
      currentPage: 1,
      YearOption: [],
      Year: "",
    };
  },
  methods: {
    tableHeaderCell() {
      return "background: #FFEDD1;color: #5A5854;text-align: center;";
    },
    tableCell() {
      return "background: #FFFFFF;color: #5A5854;text-align: center;";
    },
    regexHandleNum(cellvalues) {
      //return num.replace(/\B(?=(\d{3})+(?!\d))/g, ","); // 3是千分位，4是万分位
      //if (!!cellvalues) {
        if (cellvalues>=0) {
          cellvalues=parseFloat(cellvalues).toFixed(2);
          let [sInt, sFloat] = cellvalues.toString().split(".");
          sInt = sInt.replace(/\d(?=(\d{3})+$)/g, "$&,");
          return (cellvalues = sFloat ? `${sInt}.${sFloat}` : `${sInt}`);
       // }
      } else {
        return cellvalues;
      }
    },
    BindData() {
      this.loading = true;
      this.$api
        .get("/CR/PLMCRProjectCostSummary", {
          ID: this.IDs.toString(),
        })
        .then((res) => {
          if (res.data.status == true) {
            res.data.content.forEach((element) => {
              element.capex = this.regexHandleNum(element.capex);
              element.opex = this.regexHandleNum(element.opex);
              element.digital = this.regexHandleNum(element.digital);
            });
            this.newTableData = res.data.content.filter((c) => {
              return c.action === "New";
            });
            this.upTableData = res.data.content.filter((c) => {
              return c.action === "Upgrade";
            });
          } else {
            if (res.data.message == "Login Error") {
              this.$router.push({ path: "/" });
            } else {
              this.$message({
                type: "error",
                message: res.data.message,
              });
              return false;
            }
          }
          this.loading = false;
        });
    },
    Init() {
      let IDs = "";
      let obj = sessionStorage.getItem("Cr_Add_Ids")
        ? JSON.parse(sessionStorage.getItem("Cr_Add_Ids"))
        : null;
      if (this.$route.params.ID) {
        IDs = this.$route.params.ID;
      } else if (!!obj) {
        IDs = obj.ID;
      }
      this.IDs = IDs;
      this.BindData();
    },
    transferToDecimal(cellvalues) {
      if (!!cellvalues && typeof cellvalues === "number") {
        if (cellvalues > 0) {
          let [sInt, sFloat] = cellvalues.toString().split(".");
          sInt = sInt.replace(/\d(?=(\d{3})+$)/g, "$&,");
          return (cellvalues = sFloat ? `${sInt}.${sFloat}` : `${sInt}`);
        }
      } else {
        return cellvalues;
      }
    },
    getMaxLength(arr) {
      return arr.reduce((acc, item) => {
        if (item) {
          let c = this.getTextWidth(item);
          if (acc < c) {
            acc = c;
          }
        }
        return acc;
      }, 0);
    },
    getTextWidth(str) {
      let width = 0;
      const html = document.createElement("span");
      html.innerText = str;
      html.className = "getTextWidth";
      document.querySelector("body").appendChild(html);
      width = document.querySelector(".getTextWidth").offsetWidth;
      document.querySelector(".getTextWidth").remove();
      return width;
    },
    flexColumnWidth(label, prop) {
      const arr = this.tableData.map((x) => x[prop]);
      arr.push(label);
      return this.getMaxLength(arr) + 20 + "px";
    },
    CreateCR() {
      this.$confirm("请确认Financial Year是否为【"+this.Year+"】", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
        this.loading = true;
        this.$api
          .get(
            "/CR/GetSmartCRData/",
            { 
              ProjectID: this.IDs.toString(),
              Financial:this.Year
            },
            (res) => {}
          )
          .then((res) => {
            if (res.data.status) {
              this.$message({
                type: "success",
                message: "Submit Successful !",
              });
              this.loading = false;
              window.open("#/CRMange", "_self");
              //window.open("http://scr.kbpsoft.com",'_blank');
			        window.open("https://scr.adscld.biz/pages/Index.html?type=draft",'_blank');
            } else {
              this.$message({
                type: "error",
                message: res.data.message,
              });
              this.loading = false;
              return false;
            }
          });
      })
    .catch(() => {});
    },
    backAddSummary() {
      this.$router.push({
        name: "CRMangeAdd",
        params: {
          ID: this.IDs,
        },
      });
    },
    getYearOption() {
      let year = new Date().getFullYear();
      this.YearOption.push(year - 1, year, year + 1);
      this.Year = year;
    },
  },
  mounted() {
    this.Init();
    this.getYearOption();
  },
};
</script>

<style lang="scss" scoped>
.top {
  height: 60px;
  background: #232b33;
  color: white;
  text-align: center;
  line-height: 50px;
}
.content_title {
  margin: 10px auto 0;
  width: 90%;
  text-align: left;
  .CR-btn {
    display: flex;
    justify-content: end;
    margin-bottom: 10px;
    .search-year {
      display: flex;
      align-items: center;
    }
    .button-search {
      background-color: #e6a23c;
      border: 0px #e6a23c;
      color: #ffff;
    }
  }
}
.cr-add-table {
  width: 100%;
  &.cr-upgrade-table {
    margin-top: 10px;
  }
  .title {
    margin-bottom: 10px;
  }
  .div-pagination {
    text-align: right;
    margin-bottom: 10px;
    display: inline-block;
    width: 100%;
    padding-top: 10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/CRAddSummary.vue